import {Icon} from 'leaflet';
import marker from '../../assets/marker.png';

const mapMarkerIcon = new Icon({iconUrl: marker, iconSize: [32, 32]});

export default mapMarkerIcon;
